import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { lastValueFrom } from 'rxjs';
import { DeviceManagmentSocketService } from './device-managment-socket.service';
import { Device, Model } from 'icreate/common/models/device';
import { RuntimeEnvironments } from '../models/runtime-enviroment.enum';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root',
})
export class DeviceManagmentService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });
    private env: RuntimeEnvironments;

    constructor(
        private http: HttpClient,
        private deviceManagmentSocketService: DeviceManagmentSocketService,
        private environmentService: EnvironmentService
    ) {
        this.domain = EndPointApi.iApiDomain();
        this.env = this.environmentService.getEnvironment();
    }

    async getAll(): Promise<Device[]> {
        if (this.isRunningInElectron()) return [];
        const currentDevices = await lastValueFrom(
            this.http.get<Device[]>(`${this.domain}/api/device-managment`, {
                headers: this.headers,
            })
        );

        this.deviceManagmentSocketService.initializeList(currentDevices);

        return currentDevices;
    }

    async createDevice(deviceName: string) {
        if (this.isRunningInElectron()) return;
        return await lastValueFrom(
            this.http.post(
                `${this.domain}/api/device-managment/device`,
                { deviceName, skipGuard: true },
                { headers: this.headers }
            )
        );
    }

    async updateDevice(device: Device, deviceId) {
        if (this.isRunningInElectron()) return;
        return lastValueFrom(
            this.http.put(`${this.domain}/api/device-managment/device/${deviceId}`, {
                device,
                skipGuard: true,
            })
        );
    }

    async deleteDevice(device: Device) {
        if (this.isRunningInElectron()) return;
        return lastValueFrom(
            this.http.delete(`${this.domain}/api/device-managment/device/${device.id}`, {
                body: { device, skipGuard: true },
            })
        );
    }

    async createModel(model: Model) {
        if (this.isRunningInElectron()) return;
        return await lastValueFrom(
            this.http.post(
                `${this.domain}/api/device-managment/model`,
                { model, skipGuard: true },
                {
                    headers: this.headers,
                }
            )
        );
    }

    async updateModel(model: Model, modelId) {
        if (this.isRunningInElectron()) return;
        return lastValueFrom(
            this.http.put(`${this.domain}/api/device-managment/model/${modelId}`, {
                model,
                skipGuard: true,
            })
        );
    }

    async deleteModel(model: Model, modelId: string) {
        if (this.isRunningInElectron()) return;
        return lastValueFrom(
            this.http.delete(`${this.domain}/api/device-managment/model/${modelId}`, {
                body: { model, skipGuard: true },
            })
        );
    }

    private isRunningInElectron() {
        return this.env == RuntimeEnvironments.ELECTRON;
    }
}
